import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const nicotine = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
